import * as React from "react";
import { ProductDetailUsps } from "./ProductDetailUsps.js";
import { useCmsData } from "../../../../context/context/CmsContext.js";
const ProductDetailUspsContainer = ({
  children,
  className
}) => {
  const { usps } = useCmsData();
  return /* @__PURE__ */ React.createElement(ProductDetailUsps, { items: usps, className }, children);
};
export {
  ProductDetailUspsContainer
};
//# sourceMappingURL=ProductDetailUspsContainer.js.map
